import httpArcheo from "../helpers/http-archeo";

export const getAuthorities = async () => {
  try {
    const response = await httpArcheo.get("/api/private/v3/authority/get");
    return response?.data?.authorities;
  } catch (err) {
    throw err;
  }
};
